import React from 'react';
import { useMediaQuery } from 'react-responsive';
import EmailHostingContent from './EmailHostingContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <EmailHostingContent history={history} />
  </Mobile>
);

export default MobileResponsive;
